import {
  SAVE_ALERT_REQUESTED,
  SAVE_ALERT_FAILED,
  SEND_ALERT_REQUESTED,
  SEND_ALERT_FAILED,
} from "../actions/alert";

const initialState = {};

// handle error messaging by passing back API responses
export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_ALERT_REQUESTED:
    case SAVE_ALERT_FAILED:
    case SEND_ALERT_REQUESTED:
    case SEND_ALERT_FAILED:
      return { ...action.payload };
    default:
      return state;
  }
};
